export default __webpack_public_path__ + "static/media/amisragreen.bcd4a716.png";